import { lazy } from 'react'
import type { RouteObject } from 'react-router'
import { page } from '@/shared/ui'

const QaPage = lazy(() => import('@/roles/sv/pages/QaPage'))
const MorePage = lazy(() => import('@/roles/sv/pages/MorePage'))
const CommPage = lazy(() => import('@/roles/sv/pages/CommPage'))
const HomePage = lazy(() => import('@/roles/sv/pages/HomePage'))
const ServiceHomePage = lazy(() => import('@/roles/sv/pages/ServiceHomePage'))
const InspPage = lazy(() => import('@/roles/sv/pages/InspPage'))
const InspDetailPage = lazy(() => import('@/roles/sv/pages/InspDetailPage'))
const HistPage = lazy(() => import('@/roles/sv/pages/HistPage'))
const ActPage = lazy(() => import('@/roles/sv/pages/ActPage'))
const SalesPage = lazy(() => import('@/roles/sv/pages/SalesPage'))
const SvStoresPage = lazy(() => import('@/roles/sv/pages/SvStoresPage'))
const StoreDocsPage = lazy(() => import('@/roles/sv/pages/StoreDocsPage'))
const PrmPage = lazy(() => import('@/roles/sv/pages/PrmPage'))
const ConstructionPage = lazy(() => import('@/roles/sv/pages/ConstructionPage'))
const VisitPlanPage = lazy(() => import('@/roles/sv/pages/VisitPlanPage'))
const TplPage = lazy(() => import('@/roles/sv/pages/TplPage'))
const VocPage = lazy(() => import('@/roles/sv/pages/VocPage'))
const VotePage = lazy(() => import('@/roles/sv/pages/VotePage'))
const VoteDetailPage = lazy(() => import('@/roles/sv/pages/VoteDetailPage'))
const VoteCreatePage = lazy(() => import('@/roles/sv/pages/VoteCreatePage'))
const AsPage = lazy(() => import('@/roles/sv/pages/AsPage'))
const ClaimPage = lazy(() => import('@/roles/sv/pages/ClaimPage'))
const QnaPage = lazy(() => import('@/roles/sv/pages/QnaPage'))
const NoticePage = lazy(() => import('@/roles/sv/pages/NoticePage'))
const InqChatPage = lazy(() => import('@/roles/sv/pages/InqChatPage'))
const SettingsPage = lazy(() => import('@/roles/sv/pages/SettingsPage'))
const AiAssistantPage = lazy(() => import('@/roles/sv/pages/AiAssistantPage'))

export const SV_HOME = '/home'

/** SvShell 안에 그려지는 화면 */
export const svRoutes: RouteObject[] = [
  { path: 'home', element: page(HomePage) },
  { path: 'more', element: page(MorePage) },
  { path: 'comm', element: page(CommPage) },
  ...(['qsc', 'prm'] as const).map((service) => ({
    path: `${service}/home`,
    element: page(ServiceHomePage, { service }),
  })),
  ...(['home', 'tpl', 'insp', 'act', 'suppliers'] as const).map((section) => ({
    path: `qa/${section}`,
    element: page(QaPage, { section }),
  })),
  { path: 'insp', element: page(InspPage) },
  { path: 'insp/:inspNo', element: page(InspDetailPage) },
  { path: 'hist', element: page(HistPage) },
  { path: 'act', element: page(ActPage) },
  { path: 'sales', element: page(SalesPage) },
  { path: 'svstore', element: page(SvStoresPage) },
  { path: 'svstore/:storeCd/docs/:docType?', element: page(StoreDocsPage) },
  { path: 'prm', element: page(PrmPage) },
  { path: 'construction', element: page(ConstructionPage) },
  { path: 'visitplan', element: page(VisitPlanPage) },
  { path: 'tpl', element: page(TplPage) },
  { path: 'voc', element: page(VocPage) },
  { path: 'vote', element: page(VotePage) },
  { path: 'vote/new', element: page(VoteCreatePage) },
  { path: 'vote/:pollId', element: page(VoteDetailPage) },
  { path: 'as/:asId?', element: page(AsPage) },
  { path: 'claim/:claimId?', element: page(ClaimPage) },
  { path: 'notice/:noticeId?', element: page(NoticePage) },
  { path: 'qna', element: page(QnaPage) },
  { path: 'inq/:inqNo', element: page(InqChatPage) },
  { path: 'settings', element: page(SettingsPage) },
]

/** 셸 없이 전체 화면으로 그려지는 화면 */
export const svFullscreenRoutes: RouteObject[] = [{ path: 'ai', element: page(AiAssistantPage) }]
